import { actionCreators as Notification } from './Notification';
import restHttp from '../../utils/restHttp';

const requestPostType = 'loyality/image/post/request';
const receivePostType = 'loyality/image/post/receive';
const clearType = 'loyality/image/clear';

const initialState = {
  id: null,
};

export const actionCreators = {
  requestPost: file => (dispatch) => {
    dispatch({ type: requestPostType });

    const data = new FormData();
    data.append('file', file);

    restHttp
      .post('image', data)
      .then((response) => {
        dispatch({
          type: receivePostType,
          imageId: response.data,
        });
      })
      .catch((error) => {
        dispatch(Notification.addError(error));
      });
  },
  clear: () => (dispatch) => {
    dispatch({ type: clearType });
  },
};

export const reducer = (state, action) => {
  const newState = state || initialState;

  if (action.type === requestPostType || action.type === clearType) {
    return {
      ...newState,
      id: null,
    };
  }

  if (action.type === receivePostType) {
    return {
      ...newState,
      id: action.imageId,
    };
  }

  return newState;
};



// WEBPACK FOOTER //
// ./src/store/modules/Image.js